import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { ref, watch } from "vue";
import {} from "@/api/notifications";
import { snakeCaseToTitleCase } from "@/utils/strings";
export default /*#__PURE__*/ _defineComponent({
    __name: 'NotificationsChannelSettings',
    props: {
        preferences: null,
        category: null,
        isCategoryEnabled: { type: Boolean },
        channel: null
    },
    emits: ["onChange"],
    setup(__props, { emit }) {
        const props = __props;
        library.add(faExclamationCircle);
        const value = ref(props.preferences[props.category].channels[props.channel]);
        watch(() => value.value, (newValue) => {
            emit("onChange", props.category, props.channel, newValue);
        });
        return { __sfc: true, props, emit, value, faExclamationCircle, FontAwesomeIcon, snakeCaseToTitleCase };
    }
});
